/**
 * Canonical sets of operator aliases for condition matching.
 * Reused by rule-conversion.ts and rule-human-readable.ts.
 *
 * All sets contain RAW operator strings (as produced by AI or stored in DB).
 * Do NOT normalize operators before checking against these sets.
 */
// ─── Date operators ──────────────────────────────────────────────────────────
export const DATE_BEFORE_OPERATORS = new Set([
    'date-before',
    'date-before-or-equals',
    'less',
    '<',
    'less-than',
    'less_than',
    'less_equal',
    '<=',
    'less-than-or-equals',
]);
export const DATE_AFTER_OPERATORS = new Set([
    'date-after',
    'date-after-or-equals',
    'greater',
    '>',
    'greater-than',
    'greater_than',
    'greater_equal',
    '>=',
    'greater-than-or-equals',
]);
export const DATE_EQUALS_OPERATORS = new Set([
    'date-equals',
    'equals',
    '=',
    'equal',
]);
// ─── Amount operators ────────────────────────────────────────────────────────
export const AMOUNT_LESS_OPERATORS = new Set([
    'less',
    '<',
    'less-than',
    'less_than',
    'lessThan',
]);
export const AMOUNT_LESS_EQUAL_OPERATORS = new Set([
    'less_equal',
    '<=',
    'less-than-or-equals',
    'less_or_equal',
    'less-or-equal',
    'lessThanOrEquals',
]);
export const AMOUNT_GREATER_OPERATORS = new Set([
    'greater',
    '>',
    'greater-than',
    'greater_than',
    'greaterThan',
]);
export const AMOUNT_GREATER_EQUAL_OPERATORS = new Set([
    'greater_equal',
    '>=',
    'greater-than-or-equals',
    'greater_or_equal',
    'greater-or-equal',
    'greaterThanOrEquals',
]);
export const AMOUNT_EQUALS_OPERATORS = new Set(['equals', '=', 'equal']);
/** Any operator that represents an amount lower bound (> or >=) */
export const AMOUNT_LOWER_BOUND_OPERATORS = new Set([
    ...AMOUNT_GREATER_OPERATORS,
    ...AMOUNT_GREATER_EQUAL_OPERATORS,
]);
/** Any operator that represents an amount upper bound (< or <=) */
export const AMOUNT_UPPER_BOUND_OPERATORS = new Set([
    ...AMOUNT_LESS_OPERATORS,
    ...AMOUNT_LESS_EQUAL_OPERATORS,
]);
